<template>
  <div class="right-chart-1">
    <div>
      <div class="rc1-header">总计运单数</div>

      <div class="rc1-chart-container">

        <div class="cc-details">
          <div class="card" :key="index" v-for="(item,index) of String(businessTotal)">{{ item }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RightChart1',
  props: {
    businessTotal: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
    }
  }
}
</script>

<style lang="less">
.right-chart-1 {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  .rc1-header {
    font-size: 24px;
    font-weight: bold;
    height: 30px;
    text-align: center;
    line-height: 30px;
  }

  .rc1-chart-container {
    flex: 1;
    .cc-details {
      height: 120px;
      display: flex;
      justify-content: center;
      font-size: 32px;
      align-items: center;

      .card {
        background-color: rgba(4,49,128,.6);
        color: #08e5ff;
        height: 70px;
        width: 70px;
        font-size: 45px;
        font-weight: bold;
        line-height: 70px;
        text-align: center;
        margin: 10px;
      }
    }
  }

  .left {
    width: 30%;
    font-size: 16px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .number {
      font-size: 34px;
      color: #096dd9;
      font-weight: bold;
      margin-bottom: 30px;
    }
  }

  .right {
    flex: 1;
    padding-bottom: 20px;
    padding-right: 20px;
    box-sizing: border-box;
  }

}
</style>
